<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="turnos" tipo="table-heading, card, image, table-tfoot"></SkeletonLoader>
    </v-container>
    <v-container v-else>
        <DialogoEliminar2 ref="refEliminar" :tipo="tipo" :mensaje="mensaje">
        </DialogoEliminar2>
        <DialogoEliminar ref="refDialogoEliminar" titulo="Eliminar" :tipo="tipo" />
        <!-- @refreshItems="actualizarItems" -->
        <DialogoEditar ref="dialogoEditarContacto" :tipo="tipo" :key="dialogoKey" />
        <v-card flat>
            <v-card-title class="text-h5 font-weight-bold ">
                <v-icon color="primary" class="mr-3" size="34">mdi-email-outline</v-icon>
                Información de contacto
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card flat class="rounded-0">
                <v-col>
                    <v-card-title class="font-weight-bold primary--text pl-0">
                        <v-icon class="mr-2" color="red">mdi-map-marker-outline</v-icon>
                        Mis domicilios
                        <v-avatar color="primary darken-1" size="29"
                            class="ml-3 font-weight-bold white--text text-body-2">
                            {{ Object.keys(this.domicilio).length }}
                        </v-avatar>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="lanzarDialogo({ localidad: '' })" small class="pa-5 elevation-0"
                                    v-bind="attrs" v-on="on" color="primary lighten-1">
                                    <v-icon class="mr-1">mdi-map-marker-plus-outline</v-icon>
                                    <div class="font-weight-bold">
                                        nuevo
                                    </div>
                                </v-btn>
                            </template>
                            <span>Nuevo domicilio</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-data-table :headers="cabeceraDom" :items="domicilio" class="rounded-0 border" hide-default-footer
                        disable-pagination sort-by="recibecorreo" sort-desc :key="refreshKey">
                        <template v-slot:item.formatDireccion="{ item }">
                            {{ item.calle }} {{ item.nro }} {{ item.piso }} {{ item.dep }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-row justify="center" align="center">
                                <v-col cols="6" class="d-flex justify-end">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" fab small outlined
                                                @click="lanzarDialogo(item)" class="pa-4" color="primary">
                                                <v-icon>mdi-pencil-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="6" class="d-flex justify-start">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-if="Object.keys(domicilio).length > 1 && item.recibecorreo !== 1"
                                                v-bind="attrs" fab small v-on="on" @click="eliminarItem(item)"
                                                color="error" outlined class="pa-4">
                                                <v-icon>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.recibecorreo="{ item }">
                            <v-row class="mt-1 justify-center align-center">
                                <v-checkbox v-model="item.recibecorreo" :true-value=1 :false-value=0 readonly
                                    color="primary"></v-checkbox>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-col>
            </v-card>
            <v-card class="rounded-0" flat>
                <v-col>
                    <v-card-title class="font-weight-bold primary--text pl-0">
                        <v-icon class="mr-2" color="green">mdi-phone-outline</v-icon>
                        Mis telefonos
                        <v-avatar color="primary darken-1" size="29"
                            class="ml-3 font-weight-bold white--text text-body-2">
                            {{ Object.keys(this.telefono).length }}
                        </v-avatar>
                        <v-spacer></v-spacer>
                        <v-btn small @click="lanzarDialogo({ telefono: '' })" color="primary lighten-1"
                            class="elevation-0 pa-5">
                            <v-icon class="mr-2">mdi-phone-plus-outline</v-icon>
                            Nuevo
                        </v-btn>
                    </v-card-title>
                    <v-data-table :headers="cabeceraTel" :items="telefono" class="border rounded-0" hide-default-footer
                        disable-pagination sort-desc sort-by="recibellamada" :key="refreshKey">
                        <template v-slot:item.formatTel="{ item }">
                            {{ '(+' + item.codpais + ') ' + item.carac + '-' + item.telefono }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-row justify="center" align="center">
                                <v-col cols="6" class="d-flex justify-end">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" fab small @click="lanzarDialogo(item)"
                                                outlined class="mx-2 pa-4" color="primary">
                                                <v-icon>mdi-pencil-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="6" class="d-flex justify-start">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-if="Object.keys(telefono).length > 1 && item.recibellamada !== 1"
                                                v-bind="attrs" fab small v-on="on" @click="eliminarItem(item)"
                                                color="error" outlined class="pa-4">
                                                <v-icon>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.recibellamada="{ item }">
                            <v-row class="mt-1 justify-center align-center">
                                <v-checkbox v-model="item.recibellamada" :true-value=1 :false-value=0 readonly
                                    color="primary"></v-checkbox>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-col>
            </v-card>
            <v-card class="rounded-0" flat>
                <v-col>
                    <v-card-title class="font-weight-bold primary--text pl-0">
                        <v-icon class="mr-2" color="indigo">mdi-email-outline</v-icon>
                        Mis email
                        <v-avatar color="primary darken-1" size="29"
                            class="ml-3 font-weight-bold white--text text-body-2">
                            {{ Object.keys(this.email).length }}
                        </v-avatar>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" small @click="lanzarDialogo({ email: '' })"
                                    class="elevation-0 pa-5" color="primary lighten-1">
                                    <v-icon class="mr-2">mdi-email-plus-outline</v-icon>
                                    <div class="font-weight-bold">
                                        nuevo
                                    </div>
                                </v-btn>
                            </template>
                            <span>Nuevo email</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-data-table :headers="cabeceraMail"
                        :items="email" class="border rounded-0" hide-default-footer disable-pagination
                        sort-by="recibeemail" sort-desc :key="refreshKey">
                        <template v-slot:item.actions="{ item }">
                            <v-row justify="center" align="center">
                                <v-col cols="6" class="d-flex justify-end">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" fab small @click="lanzarDialogo(item)"
                                                outlined class="mx-2 pa-4" color="primary">
                                                <v-icon>mdi-pencil-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="6" class="d-flex justify-start">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <!-- v-if="Object.keys(email).length > 1 && item.recibeemail !== 1" -->
                                            <v-btn v-if="Object.keys(email).length > 1 && item.recibeemail !== 1"
                                                v-bind="attrs" fab small v-on="on" @click="eliminarItem(item)"
                                                color="error" outlined class="pa-4">
                                                <v-icon>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.recibeemail="{ item }">
                            <v-row class="mt-1 justify-center align-center">
                                <v-checkbox v-model="item.recibeemail" :true-value=1 :false-value=0 readonly
                                    color="primary"></v-checkbox>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-col>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
// diagrama UML: 
// https://app.diagrams.net/#G138O54fn29wj0HUQ60Mh9stUa970egjwQ

import { mapActions, mapGetters } from 'vuex';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'
import DialogoEliminar from '@/components/dialogos/DialogoEliminar'
import DialogoEliminar2 from '@/components/dialogos/DialogoEliminar2.vue'
import DialogoEditar from '@/components/dialogos/DialogoAddEdit.vue'

export default {
    components: {
        DialogoEditar,
        DialogoEliminar,
        DialogoEliminar2,
        SkeletonLoader
    },
    data() {
        return {
            cabeceraDom: [
                { text: 'LOCALIDAD', value: 'localidad', align: 'center', sortable: false },
                { text: 'DIRECCION', value: 'formatDireccion', align: 'center', sortable: false },
                { text: 'PROVINCIA', value: 'desprov', align: 'center', sortable: false },
                { text: 'TIPO', value: 'destipcontacto', align: 'center', sortable: false },
                { text: 'PRINCIPAL', value: 'recibecorreo', align: 'center', sortable: false },
                { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' }
            ],
            cabeceraMail: [
                { text: 'EMAIL', value: 'email', align: 'center', sortable: false },
                { text: 'TIPO', value: 'destipcontacto', sortable: false, align: 'center' },
                { text: 'PRINCIPAL', value: 'recibeemail', sortable: false, align: 'center' },
                { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' },
            ],
            cabeceraTel: [
                { text: 'NRO. DE TELÉFONO', value: 'formatTel', align: 'center', sortable: false },
                { text: 'TIPO TEL.', value: 'destiptelefono', align: 'center', sortable: false },
                { text: 'PRINCIPAL.', value: 'recibellamada', align: 'center', sortable: false },
                { text: 'ACCIONES', value: 'actions', sortable: false, align: 'center' },
            ],

            tipo: '',
            titulo: '',
            tipoMod: '',
            fab: false,
            itemSeleccionado: '',
            dialogoKey: 0, // Clave para forzar el refresco del dialogo
            refreshKey: 0 // Clave para forzar el refresco de los data-tables
        }
    },
    methods: {
        ...mapActions('common', ['levantarCommon']),
        ...mapActions('itemEdit', ['vaciarItem', 'cargarItem']),
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions(['sendTelefono', 'sendDomicilio', 'sendEmail']),


        lanzarDialogo(item) {
            this.itemSeleccionado = { ...item }
            this.cargarItem(this.itemSeleccionado)
            this.tipo = this.tipoContacto
            this.$refs.dialogoEditarContacto.abrirDialog().then(result => {
                if (result) {

                }
            })
        },
        eliminarItem(item) {
            this.itemSeleccionado = { ...item, accion: 'B' }
            this.cargarItem(this.itemSeleccionado)
            this.tipo = this.tipoContacto
            this.mensaje = `¿Estás segura/o que querés eliminar el ${this.tipo}?`;
            if (item.recibeemail == 0 || item.recibecorreo == 0 || item.recibellamada == 0) {
                this.$refs.refEliminar.abrirDialogo().then(result => {
                    if (result) {
                        switch (this.tipo) {
                            case 'telefono':
                                this.sendTelefono(this.itemSeleccionado)
                                break;
                            case 'email':
                                this.sendEmail(this.itemSeleccionado)
                                break;
                            case 'domicilio':
                                this.sendDomicilio(this.itemSeleccionado)
                                break;
                            default:
                                break;
                        }
                        //location.reload()
                    }
                })
            } else {
                this.showSnack({
                    message: 'No puede eliminar porque esta marcado como principal',
                    type: '400'
                })
            }
        },

        eliminarItem2(item) {
            this.tipoContacto()
            this.cargarItem(item)
            this.itemSeleccionado = item
            this.itemSeleccionado.accion = "B"
            if (item.recibeemail == 0 || item.recibecorreo == 0 || item.recibellamada == 0) {
                this.$refs.refDialogoEliminar.lanzar().then(result => {
                    if (result) {
                        switch (this.tipo) {
                            case 'telefono':
                                this.sendTelefono(this.itemSeleccionado)
                                break;
                            case 'email':
                                this.sendEmail(this.itemSeleccionado)
                                break;
                            case 'domicilio':
                                this.sendDomicilio(this.itemSeleccionado)
                                break;
                            case 'desconocido':
                                this.showSnack({
                                    message: 'Tipo de contacto invalido.',
                                    type: '400'
                                })
                                break
                            default:
                                break;
                        }
                        location.reload()
                    }
                })
            } else {
                this.showSnack({
                    message: 'No puede eliminar porque esta marcado como principal',
                    type: '400'
                })
            }
        },
        /* asignarTipo(item) {
            if ('localidad' in item) {
                this.tipo = 'domicilio';
            } else if ('telefono' in item) {
                this.tipo = 'telefono';
            } else if ('email' in item) {
                this.tipo = 'email';
            } else {
                this.tipo = 'desconocido';
            }
        }, */
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'user', 'loadSkeleton']),
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters(['telefono', 'email', 'domicilio', 'telefonoPrinc', 'emailPrinc', 'domicilioPrinc']),
        tipoContacto() {
            if (Object.keys(this.itemSeleccionado).includes('localidad')) {
                return 'domicilio'
            } else if (Object.keys(this.itemSeleccionado).includes('telefono')) {
                return 'telefono'
            } else if (Object.keys(this.itemSeleccionado).includes('email')) {
                return 'email'
            }

        }
    }
};
</script>